module.exports = __webpack_public_path__ + "static/img/header.93b20d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header.png
// module id = 509
// module chunks = 1 2 3 4 5 6